export const formatDateString=(date)=>{



// Create the formatted date string
const formattedDateString = date.slice(0,10);

return formattedDateString;
}